import { render } from "./AdminLeadDetail.vue?vue&type=template&id=9069b120&scoped=true"
import script from "./AdminLeadDetail.vue?vue&type=script&lang=js"
export * from "./AdminLeadDetail.vue?vue&type=script&lang=js"

import "./AdminLeadDetail.vue?vue&type=style&index=0&id=9069b120&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9069b120"]])

export default __exports__